import React from 'react';
import { Link } from 'react-router-dom';
import { PiCopyrightBold } from 'react-icons/pi';
import SocialMedia from '../social media/SocialMedia';
import { useData } from '../../context/DataContext';
import useSectionNavigate from '../../hooks/useSectionNavigate';
import { sectionHref } from '../../config/sections';
import './footer.css';

const QUICK_LINKS = [
    { label: 'Home', section: 'home' },
    { label: 'About Me', section: 'about' },
    { label: 'Skills', section: 'skills' },
    { label: 'Projects', section: 'portfolio' },
    { label: 'Blogs', to: '/blog' },
];

const isModifiedClick = (e) =>
    e.button !== 0 || e.metaKey || e.altKey || e.ctrlKey || e.shiftKey;

const currentYear = new Date().getFullYear();

const Footer = () => {
    const goToSection = useSectionNavigate();
    const { data } = useData();
    const { site } = data;

    return (
        <div className="footer-container">
            <div className="footer-content-wrapper container">
                <div className="footer-content">
                    <h2>About Me</h2>
                    <ul>
                        <li>
                            <p className="text-[14px]">
                                A full-stack web developer from India, merging creative design with powerful functionality.
                            </p>
                        </li>
                        <SocialMedia size={18} className="mt-3" />
                    </ul>
                </div>

                <div className="footer-content">
                    <h2>Contact Me</h2>
                    <ul className="flex flex-col gap-2">
                        <li>{site.location}</li>
                        <li>
                            <a href={`tel:${site.phone}`}>{site.phone}</a>
                        </li>
                        <li className="wrap-break">
                            <a href={`mailto:${site.email}`}>{site.email}</a>
                        </li>
                    </ul>
                </div>

                <div className="footer-content">
                    <h2>Quick Links</h2>
                    <ul className="flex flex-col gap-2 footer-ul">
                        {QUICK_LINKS.map((item) =>
                            item.section ? (
                                <li key={item.label}>
                                    <a
                                        className="footer-link"
                                        href={sectionHref(item.section)}
                                        onClick={(e) => {
                                            if (isModifiedClick(e)) return;
                                            e.preventDefault();
                                            goToSection(item.section);
                                        }}
                                    >
                                        {item.label}
                                    </a>
                                </li>
                            ) : (
                                <li key={item.label}>
                                    <Link className="footer-link" to={item.to}>
                                        {item.label}
                                    </Link>
                                </li>
                            )
                        )}
                    </ul>
                </div>

                <div className="footer-content">
                    <h2 className="flex items-start gap-1 lg:items-center justify-start leading-6">
                        <PiCopyrightBold /> {site.name}
                    </h2>
                    <ul>
                        <li>
                            MADE WITH ❤️ BY
                            <div>
                                <i>{site.name}</i>.
                            </div>
                        </li>
                    </ul>
                </div>
            </div>

            <div className="footer-bottom">
                <div className="container footer-bottom-inner">
                    <span>
                        © {currentYear} {site.name}. All rights reserved.
                    </span>
                    <span className="footer-bottom-built">
                        Built with React &amp; Tailwind CSS
                    </span>
                </div>
            </div>
        </div>
    );
};

export default Footer;
